import { Component, OnInit } from "@angular/core";
declare var jquery: any;
declare var $: any;
import { HttpClient } from "@angular/common/http";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "app-approvelist",
  templateUrl: "./approvelist.component.html",
  styleUrls: ["./approvelist.component.css"]
})
export class ApproveListComponent implements OnInit {

  constructor(
    private httpService: HttpClient
  ) {}

  ngOnInit() {
    this.loadDefaultScript(); 
    this.getFreelanceRegister();
  } 

  getFreelanceRegister(){
    setTimeout(() => {
      $("#tb_freelance_register").DataTable({
        retrieve: true,
        paging: true,
        responsive: true
      });
    }, 0);
  }

  //load default script
  loadDefaultScript() {
     
  }
  //end load default script
}
